import api from './../api';
import request from "../utils/requestToJavaServer";
export function Common_Code(formData: FormData) {
    return new Promise((resolve, reject) => {
        request.post(api.commonApi.COMMON_CODE, formData).then((res) => {
            resolve(res);
        }).catch((err) => {
            reject(err);
        })
    })
}

export function Common_Verify(formData: FormData) {
    return new Promise((resolve, reject) => {
        request.post(api.commonApi.COMMON_VERIFY, formData).then((res) => {
            resolve(res);
        }).catch((err) => {
            reject(err);
        })
    })
}

export function Common_Verify_Code(formData: FormData) {
    return new Promise((resolve, reject) => {
        request.post(api.commonApi.COMMON_VERIFY_CODE, formData).then((res) => {
            resolve(res);
        }).catch((err) => {
            reject(err);
        })
    })
}